<mat-nav-list class="global-nav-list">
    <!-- LICENSES -->
    <a
        *appPermissionIf="'licenseViewAll'"
        class="link nav-list-item"
        mat-list-item
        href="/licenses"
        (click)="openModule($event, '/licenses')"
        [class.selected]="isActiveRoute('/licenses')">
        <span class="ico icon-key"></span>
        {{ 'licenses' | translate }}
    </a>

    <!-- LICENSES END -->

    <!-- COMPANIES -->
    <a
        class="nav-list-item"
        *appPermissionIf="'businessViewAll'"
        mat-list-item
        href="/companies"
        (click)="openModule($event, '/companies')"
        [class.selected]="isActiveRoute('/companies')">
        <span class="ico icon-company"></span>
        {{ 'companies' | translate }}
    </a>
    <!-- COMPANIES END -->

    <!--DEALERS-->
    <a
        class="nav-list-item"
        *appPermissionIf="'dealerViewAll'"
        mat-list-item
        href="/dealers"
        (click)="openModule($event, '/dealers')"
        [class.selected]="isActiveRoute('/dealers')">
        <span class="ico icon-dealer"></span>
        {{ 'dealers' | translate }}
    </a>
    <!--DEALERS END-->

    <!-- PRODUCTS -->
    <a
        class="nav-list-item"
        *appPermissionIf="'productViewAll'"
        mat-list-item
        href="/products"
        (click)="openModule($event, '/products')"
        [class.selected]="isActiveRoute('/products')">
        <span class="ico icon-products"></span>
        {{ 'products' | translate }}
    </a>
    <!-- PRODUCTS END-->

    <!-- UPDATES -->
    <a
        class="nav-list-item"
        *appPermissionIf="'versionUpdateViewAll'"
        mat-list-item
        href="/updates/versions"
        (click)="openModule($event, '/updates/versions')"
        [class.selected]="isActiveRoute('/updates')">
        <span class="ico icon-clock"></span>
        {{ 'updates' | translate }}
    </a>
    <!-- UPDATES END -->

    <!-- USER MANAGEMENT -->
    <a
        class="nav-list-item"
        *appPermissionIf="'userManagementViewAll'"
        mat-list-item
        href="/user-management"
        (click)="openModule($event, '/user-management')"
        [class.selected]="isActiveRoute('/user-management')">
        <span class="ico icon-collaboration"></span>
        {{ 'user_management' | translate }}
    </a>
    <!-- USER MANAGEMENT END -->

    <!-- DASHBOARD -->
    <a
        class="nav-list-item"
        *appPermissionIf="'dashboardViewAll'"
        mat-list-item
        href="/dashboard"
        (click)="openModule($event, '/dashboard')"
        [class.selected]="isActiveRoute('/dashboard')">
        <span class="ico icon-dashboard"></span>
        {{ 'integrator_dashboard' | translate }}
    </a>
    <!-- DASHBOARD END -->

    <!-- REPORTS -->
    <a
        class="nav-list-item"
        *appPermissionIf="'reportViewAll'"
        mat-list-item
        href="/reports"
        (click)="openModule($event, '/reports')"
        [class.selected]="isActiveRoute('/reports')">
        <span class="ico icon-folder"></span>
        {{ 'reports' | translate }}
    </a>
    <!-- REPORTS END -->

    <!-- ACTIVITIES DASHBOARD -->
    <a
        class="nav-list-item"
        *appPermissionIf="'giftCardViewAll'"
        mat-list-item
        href="/activities"
        (click)="openModule($event, '/activities')"
        [class.selected]="isActiveRoute('/activities')">
        <span class="ico icon-list"></span>
        {{ 'activities' | translate }}
    </a>
    <!-- REPORTS END -->

    <!-- ADDONS DASHBOARD -->
    <a
        class="nav-list-item"
        *appPermissionIf="'addOnViewAll'"
        mat-list-item
        href="/addons"
        (click)="openModule($event, '/addons')"
        [class.selected]="isActiveRoute('/addons')">
        <span class="ico icon-bag"></span>
        {{ 'addons' | translate }}
    </a>
    <!-- REPORTS END -->
</mat-nav-list>
